<template>
<div id="app">
   <div class="app__header">
      <img src="/asset/image/illustration.svg" alt="" class="app-logo"/>
      <div class="app__header-text">
         <div class="text-snipjack">
            DAVID JACK
         </div>
         <div class="text-secondary">
            Artistic Master
         </div>
      </div>
   </div>

   <div class="app__container">
      <div class="app__nav">
         <b-nav fill>
            <b-nav-item to="/">Home</b-nav-item>
            <b-nav-item to="/services">Services</b-nav-item>
            <b-nav-item to="/products">Products</b-nav-item>
            <b-nav-item :href="`tel:${phone_main}`">{{phone_formatted}}</b-nav-item>
         </b-nav>
      </div>
      
      <div class="app_icon-nav">
         <a class="app_icon-nav-item icon-nav__facebook" href="https://www.facebook.com/davidjackhaircom-118501174848823/"
            target="_blank"
            title="facebook">
            <i class="fab fa-facebook-f"></i>
         </a>
         <a class="app_icon-nav-item icon-nav__twitter" href="https://twitter.com/DavidJackHair"
            target="_blank"
            title="twitter">
            <i class="fab fa-twitter"></i>
         </a>
         <router-link class="app_icon-nav-item icon-nav__gift" to="/gift_certificate"
            title="gift certificates">
            <i class="fas fa-gift"></i>
         </router-link>
         <router-link class="app_icon-nav-item icon-nav__cut" to="/appointment"
            title="appointments">
            <i class="fas fa-cut"></i>
         </router-link>
         <a class="app_icon-nav-item icon-nav__map" :href="url_location"
            target="_blank"
            title="directions">
            <i class="fas fa-map-marked-alt"></i>
         </a>
      
      </div>

      <div>
         <div class="app-view__route">
            <router-view :key="$route.fullPath"/>
         </div>
      </div>
      <div class="app__footer-nav">
         <b-nav fill :vertical="window_width < 768" v-if="window_width > 0">
            <b-nav-item to="/">Home</b-nav-item>
            <b-nav-item to="/about">About David</b-nav-item>
            <b-nav-item to="/appointment">Appointments</b-nav-item>
            <b-nav-item to="/contact">Contact David</b-nav-item>
            <b-nav-item to="/gift_certificate">Gift</b-nav-item>
         </b-nav>
      </div>

   </div>
</div>
</template>

<script>
'use strict';
// import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';
import util from '@/util';

export default {
   components: {
   },// /components{}

   data(){
      return {
         resize_timeout: 0,
      }
   },// /data()

   computed:{
      phone_formatted(){
         return util.format_phone_dots( this.phone_main );
      },// /phone_formatted()

      ...mapGetters([
         'phone_main',
         'url_location',
         'window_width',
      ]),
   },// /computed()

   methods:{
      on_window_resize(){
         clearTimeout( this.resize_timeout );
         this.resize_timeout = setTimeout( ()=>{
            this.on_window_resized();
         }, 50 )
      },// /on_window_resize()

      on_window_resized(){
         clearTimeout( this.resize_timeout );
         this.$store.state.window_width = window.innerWidth;
         this.$store.state.window_height = window.innerHeight;
         this.$store.state.window_largest = Math.max( window.innerWidth, window.innerHeight );
         this.$store.state.window_smallest = Math.min( window.innerWidth, window.innerHeight );
      },// /on_window_resized()
   },// /methods{}

   mounted(){
      window.removeEventListener( 'resize', this.on_window_resize );
      window.addEventListener( 'resize', this.on_window_resize );
      this.on_window_resize();
   },// /mounted()
};
</script>


<style scoped>
#app
{
   padding: 0.3em;
   max-width: 781px;
   margin: auto;
   margin-bottom: 5em;
}

.app__nav
{
   margin-bottom: 0.3em;
}

.app__nav .nav-item
{
   border-right: 1px solid #4b5157;
}

.app__nav .nav-item:last-child
{
   border-right: 0;
}

.app__nav .nav-item a
{
   color: #f3f3f3;
   background-color: #161616;
}

.app__nav .nav-item a:hover
{
   background-color: #990066;
}


.app__header
{
   display: flex;
   justify-content: flex-start;
   align-items: center;
   margin-bottom: 0.3em;
}

.app__header > *
{
   margin-right: 1em;
}

.app__header > *:last-child
{
   margin-right: 0;
}

.app-logo
{
   width: 50px;
}

.app__container
{
   border-left: 1px solid #333333;
   border-right: 1px solid #333333;
   padding: 0 0.3em;
}

.app__footer-nav
{
   background-color: #333333;
}

.app__footer-nav .nav-item a
{
   color: #f3f3f3;
   text-transform: uppercase;
   /* background-color: #161616; */
}

.app__footer-nav .nav-item a:hover
{
   /* background-color: #990066; */
   text-decoration: underline;
}


.app_icon-nav
{
   margin-bottom: 0.3em;
   display: flex;
   justify-content: flex-end;
}

.app_icon-nav > *
{
   margin-right: 0.1em;
}

.app_icon-nav > *:last-child
{
   margin-right: 0;
}

.app_icon-nav-item
{
   font-size: 1rem;
   border-radius: 0.2rem;
   width: 3rem;
   display: block;
   text-align: center;
   opacity: 0.85;
}

.icon-nav__facebook
{
   color: #f8f9fa;
   background-color: #6179ab;
}

.icon-nav__twitter
{
   color: #f8f9fa;
   background-color: #61c9e0;
}

.icon-nav__gift
{
   color: #990000;
   background-color: #fcd2ff;
}

.icon-nav__cut
{
   color: #6734fe;
   background-color: #d6d6d6;
}

.icon-nav__map
{
   color: #ff5c5c;
   background-color: #f8f9fa;
}


.app_icon-nav-item:hover
{
   opacity: 1;
}

/* Small only */
/* @media screen and (max-width: 767px){} */

/* Medium and up */
@media screen and (min-width: 768px)
{
   .app__header-text
   {
      transform: scale( 1.5,1 );
      transform-origin: 0 0;
   }
}

/* Medium only */
/*@media screen and (min-width: 768px) and (max-width: 991px) {}*/

/* Large and up */
/*@media screen and (min-width: 992px) {}*/

/* Large only */
/*@media screen and (min-width: 992px) and (max-width: 1199px) {}*/

/* X-Large and up */
/*@media screen and (min-width: 1200px) {}*/
</style>
